<script setup lang="ts">
import HeroSection from '../components/HeroSection.vue';
import PresenceSection from '../components/PresenceSection.vue';
import ServicesSection from '../components/ServicesSection.vue';
import WorkflowSection from '../components/WorkflowSection.vue';
</script>

<template>
  <HeroSection />
  <ServicesSection />
  <PresenceSection />
  <WorkflowSection />
</template>
